import React from "react";
import { Form } from "react-bootstrap";
import "./style.css";

interface EvidenceofNonconformanceProps {
  formData: any;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  disabled: boolean;
}

const EvidenceofNonconformance: React.FC<EvidenceofNonconformanceProps> = ({
  formData,
  setFormData,
  disabled
}) => {
  const handleInputChange = (
    e: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    setFormData((prevData: { EvidenceofNonconformance: any }) => ({
      ...prevData,
      EvidenceofNonconformance: {
        ...prevData.EvidenceofNonconformance,
        evidence: e.target.value,
      },
    }));
  };

  return (
    <div className="p-4">
      <Form.Control
        as="textarea"
        rows={7}
        placeholder="Add evidence...."
        className="mt-3"
        disabled = {disabled}
        value={formData.EvidenceofNonconformance?.evidence || ""}
        onChange={handleInputChange}
      />
    </div>
  );
};

export default EvidenceofNonconformance;
